<style scoped lang="scss">
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
//.line {
//  width: 100%;
//  border: 1px solid #E4E7ED;
//  margin: 5px 15px 0px 15px;
//}
.wrap_box {
  min-width: 100%;
  //min-height: 200px;
  //padding: 15px;
  display: flex; /* 设置为flex布局 */
  flex-direction: row; /* 设置为水平排列 */
  justify-content: space-between; /* 设置为两端对齐 */
  .box1,
  .box2 {
    box-sizing: border-box; /* 设置盒子模型为border-box */
    //height: 180px; /* 设置高度 */
    //border: 1px solid #E4E7ED; /* 设置背景色 */
    //border-bottom: 1px solid #E4E7ED;
    //border-left: none;
    //border-right: none;
  }

  .box1 {
    float: left; /* 设置为左浮动 */
    width: 50%; /* 设置宽度为50% */
    .box1-item {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 78px;
      font-size: 16px;
    }
  }

  .box2 {
    float: right; /* 设置为右浮动 */
    width: 50%; /* 设置宽度为50% */
    .box2-item {
      display: flex;
      flex-direction: column;
      line-height: 32px; /* 字体大小的 2 倍 */
      justify-content: flex-start;
      font-size: 16px;
      padding: 20px 20px 0 20px;
    }
  }
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/wo/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"> </yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--                :ids.sync="yt.conditions.equipmentIdList">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIdList"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"> </yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_matter_list'"-->
            <!--                :ids.sync="yt.conditions.materialIdList">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.conditions.statusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuakaishishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planStartTimeStart" :end.sync="yt.conditions.planStartTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jihuawanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planEndTimeStart" :end.sync="yt.conditions.planEndTimeEnd"> </yi_time_input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ statusList: ['2', '3', '4', '5'], orderBy: 'planStartTime,equipmentId asc' })">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <div class="state">
          <div class="state">
            <span style="width: 12px;height: 12px;border-radius: 50%;background-color: #67C23A;"></span>
            <span style="margin-left: 5px; font-size:12px">{{ $t("zhuchanpin") }}</span>
          </div>
          <div class="state" style="margin-left: 32px;">
            <span style="width: 12px;height: 12px;border-radius: 50%;background-color: #F0C78A;"></span>
            <span style="margin-left: 5px;font-size:12px">{{ $t("fuchanpin") }}</span>
          </div>
        </div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"   @click="exportExcel()"></el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #shengchangongdanhao="scope">
        <div style="display: flex;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
          <div v-if="scope.row.parentId == null" style="float:left; width: 8px;height: 8px;border-radius: 50%;background-color: #67C23A;"></div>
          <div v-if="!(scope.row.parentId == null)" style="float:left;width: 8px;height: 8px;border-radius: 50%;background-color: #F0C78A;"></div>
          <span style="margin-left: 10px;">{{ scope.row.no }}</span>
        </div>
      </template>
      <!-- 工艺指南编码 -->
      <template #gongyizhinanbianma="scope">
        <span>{{ scope.row.woProcedureList | getCode }}</span>
      </template>
      <template #expand="scope">
        <sub_list :sub="scope.row.woProcedureList" :all="scope.row" :status="scope.row.status" :equipmentId="scope.row.equipmentId"></sub_list>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              type="text"
              @click="
                operationRecord(scope.row);
                getOperateRecord(scope.row);
              "
            >
              {{ $t("caozuojilu") }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-drawer style="z-index: 1000" :visible.sync="recordDetail.dialog" :direction="recordDetail.direction" :modal="false" :wrapper-closable="true" size="35%">
      <div>
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')">
            <el-input disabled v-model="recordDetail.productionOrder"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shebeimingcheng')">
            <el-input disabled v-model="recordDetail.eqName"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('mujubianhao/mingcheng')">
            <el-input disabled v-model="recordDetail.moldName"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" label-width="145px">
            <el-input disabled v-model="recordDetail.productionName"></el-input>
          </el-form-item>
        </el-form>

        <el-card class="box-card" style="margin: 0 20px 0 20px" v-if="recordDetail.recordList.length > 0" v-for="(item, index) in recordDetail.recordList" :key="index">
          <div class="wrap_box">
            <!--左边-->
            <div class="box1">
              <!--            <div class="line"></div>-->
              <span class="box1-item">
                {{ dateFormat(item.createTime) }}
              </span>
            </div>
            <!--右边-->
            <div class="box2">
              <!--            <div class="line"></div>-->
              <div class="box2-item">
                <div style="display: flex;flex-wrap: nowrap;align-items: center">
                  <span>{{ $t("caozuoleixing") }}:</span>
                  <el-button size="mini" type="primary" style="margin-left: 12px" plain>
                    {{ $t(store.state.dictJsonAll["PRODUCTION_OPERATE_TYPE"][item.type]) }}
                  </el-button>
                </div>
                <div style="display: flex;flex-wrap: nowrap;align-items: center">
                  <span style="margin-left: 15px">{{ $t("caozuoren") }}:</span>
                  <span style="margin-left: 12px">{{ item.operator }}</span>
                </div>

                <div style="display: flex;flex-wrap: wrap;align-items: center">
                  <span v-if="item.contentResultVOS.length > 0">{{ $t("caozuoneirong") }}:</span>
                  <div v-for="(content, indexItem) in item.contentResultVOS" :key="indexItem">
                    <span style="display:flex;flex-wrap: wrap;margin-left: 12px">{{ $t(content.i18n) }}:{{ $t(content.value) }}</span>
                    <!--                    <span>{{content.value}}</span>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_production_management_wo_operate_log_list",
  data() {
    return {
      recordDetail: {
        dialog: false,
        direction: "rtl",
        productionOrder: "", //生产工单号
        eqName: "", //设备名称
        moldName: "", //模具名称、编码
        productionName: "", //产品编码、名称
        recordList: [],
      },
      fildIds: "",
      clampingtimes: null,
      columns: [
        {
          label: "shengchangongdanhao",
          prop: "no",
          type: "slot",
          sort: "string",
          width: 250,
        },
        {
          label: "ERPgongdanhao",
          prop: "erpNo",
          sort: "string",
          width: 130,
        },
        {
          label: "gongdanzhuangtai",
          type: "tag",
          sort: "string",
          prop: "status",
          width: 130,
          tags: {
            1: {
              color: "#419FFF",
              text: this.$t("xinjian"),
            },
            2: {
              color: "#419FFF",
              text: this.$t("fafang"),
            },
            3: {
              color: "#67C23A",
              text: this.$t("shengchanzhong"),
            },
            4: {
              color: "#F56C6C",
              text: this.$t("zanting"),
            },
            5: {
              color: "#67C23A",
              text: this.$t("shougongxuwangong"),
            },
            6: {
              color: "#67C23A",
              text: this.$t("wangong"),
            },
            7: {
              color: "#909399",
              text: this.$t("guanbi"),
            },
            8: {
              color: "#E6A23C",
              text: this.$t("yidiaobo"),
            },
          },
        },
        {
          label: "shebeimingcheng",
          prop: "equipment.name",
          sort: "string",
          width: 130,
        },
        {
          label: "mujubianhao",
          prop: "mould.no",
          sort: "string",
          width: 130,
        },
        {
          label: "mujumingcheng",
          prop: "mould.name",
          sort: "string",
          width: 130,
        },
        {
          label: "chanpinbianma",
          prop: "material.code",
          sort: "string",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "material.name",
          sort: "string",
          width: 130,
        },
        {
          label: "guige",
          prop: "material.spec",
          width: 130,
        },
        {
          label: "jihuashuliang",
          prop: "planQuantity",
          sort: "number",
        },
        {
          label: "shengchanshuliang",
          prop: "productionQuantity",
          width: 130,
        },
        {
          label: "shengyushengchanshuliang",
          prop: "leftProductionQuantity",
          width: 130,
        },
        {
          label: "yibaogongliangpinshu",
          prop: "finishGoodQuantity",
          width: 130,
        },

        {
          label: "yibaogongbuliangpinshu",
          prop: "finishBadQuantity",
          width: 130,
        },
        {
          label: "jihuakaishishijian",
          prop: "planStartTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "jihuawanchengshijian",
          prop: "planEndTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "shijikaishishijian",
          prop: "actualStartTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "shijiwanchengshijian",
          prop: "actualEndTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "biaozhunzhouqi(miao/mu)",
          prop: "standardCycle",
          width: 130,
        },
        {
          label: "shougongxuwanchengshijian",
          prop: "firstProcessFinishTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "wangongyuceshijian",
          prop: "preFinishTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "shengyushijian(xiaoshi)",
          prop: "leftHours",
          width: 130,
        },
        {
          label: "gongyizhinanbianma",
          prop: "craftGuide.code",
          // type: 'slot',
          width: 130,
        },
        {
          label: "beizhu",
          prop: "remark",
          // width: 130,
        },
        {
          label: "caozuo",
          type: "slot",
          width: 150,
          fixed: "right",
        },
      ],
    };
  },
  filters: {
    getCode(value) {
      if (value != null) {
        return value
          .map((item) => {
            return item.procedureCode;
          })
          .join(",");
      }
      return "";
    },
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        statusList: ["2", "3", "4", "5"],
        orderBy: "planStartTime,equipmentId asc",
      };
      this.yt.get(1);
      this.utils.event_hub.$on("WEB_WORK_ORDER_EXECUTION_REFRESH", () => {
        this.yt.get(1);
      });
    }, 300);
  },
  methods: {
    operationRecord(row) {
      this.recordDetail.dialog = true;
      this.recordDetail.productionOrder = row.no;
      this.recordDetail.eqName = row.equipment.name;
      this.recordDetail.moldName = row.mould.no + "/" + row.mould.name;
      this.recordDetail.productionName = row.material.code + "/" + row.material.name;
    },
    //操作记录
    async getOperateRecord(row) {
      await this.http
        .get("web/wo/operate/logs/listByWoId", {
          params: {
            woId: row.id,
            orderBy: "createTime asc",
          },
        })
        .then((res) => {
          this.recordDetail.recordList = res.data;
          console.log("recordList", this.recordDetail.recordList);
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        });
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = "Y-m-d h:i:s";
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds,
      };
      return format.replace(/\w/g, (o) => {
        return hash[o];
      });
    },
    // 重置
    clear() {
      this.yt.conditions = {
        createTimeStart: this.begin(),
        createTimeEnd: this.end(),
      };
      this.yt.list = [];
    },
  },
};
</script>
